import {
    SET_APPOINTMENT_ID,
    SET_DATE,
    SET_TIME,
    SET_SESSIONS_PER_WEEK,
    SET_SESSION_TYPE,
    SET_REPEAT,
    SET_SUBJECT_ID ,
    SET_APPOINTMENT_TYPE,
    RESET_FAMILY_PRESET_VALUES,
    SET_DURATION

  } from '../actions/familyPresetValuesTypes';
  
  // Initial state for family preset values
  const initialState = {
    appointmentId: null,
    date: null,
    time: null,
    sessionsPerWeek: '',
    sessiontype: '',
    repeat: '',
    subjectId: null,
    appointmentType: ''
  };
  
  // Reducer function to handle family preset value actions
  const familyPresetValuesReducer = (state = initialState, action) => {
    switch (action.type) {
      case SET_APPOINTMENT_ID:
        return { ...state, appointmentId: action.payload };
      case SET_DATE:
        return { ...state, date: action.payload };
      case SET_TIME:
        return { ...state, time: action.payload };
      case SET_SESSIONS_PER_WEEK:
        return { ...state, sessionsPerWeek: action.payload };
      case SET_SESSION_TYPE:
        return { ...state, sessiontype: action.payload };
      case SET_REPEAT:
        return { ...state, repeat: action.payload };
      case SET_SUBJECT_ID:
            return { ...state, subjectId: action.payload };
      case SET_APPOINTMENT_TYPE: 
            return { ...state, appointmentType: action.payload };
      case SET_DURATION:
            return { ...state, duration: action.payload };
      case RESET_FAMILY_PRESET_VALUES:
      return initialState;

      default:
        return state;
    }
  };
  
  export default familyPresetValuesReducer;
  